import { debounce, TextField } from "@mui/material";
import { useEffect, useMemo, useState } from "react";

type Props = {
  onChange: (companyName: string) => void;
  value: string;
  className?: string;
  disabled?: boolean;
  label?: string;
  placeholder?: string;
};

function CompanyFilterInput({
  disabled,
  className,
  label = "Entreprise",
  placeholder = "Par nom",
  value,
  onChange,
  ...props
}: Props) {
  const [localValue, setLocalValue] = useState(value || "");
  const [isUserControlled, setIsUserControlled] = useState(false);

  const setDebouncedChange = useMemo(() => debounce(onChange, 300), [onChange]);

  // Only sync from prop when user is not actively controlling the input
  useEffect(() => {
    if (!isUserControlled) {
      setLocalValue(value || "");
    }
  }, [value, isUserControlled]);

  const handleChange = (currentValue: string) => {
    setIsUserControlled(true);
    setLocalValue(currentValue);
    setDebouncedChange(currentValue);
  };

  // Reset user control when the input loses focus or after a delay
  const handleBlur = () => {
    setTimeout(() => {
      setIsUserControlled(false);
    }, 100);
  };

  return (
    <TextField
      placeholder={placeholder}
      className={className}
      disabled={disabled}
      value={localValue}
      variant="outlined"
      type="text"
      onChange={(e: any) => handleChange(e.target.value)}
      onBlur={handleBlur}
      label={label}
      style={{ width: "100%" }}
      {...props}
    />
  );
}

export default CompanyFilterInput;
